import { Observable, throwError } from 'rxjs';
import isEmpty from 'lodash.isempty';

import { ShoppingCartError } from '../classes/shopping-cart-error.class';
import { GeneralHttpError, BadRequestHttpError, InvalidParams } from '~shared/modules/error-handler';
import { CheckoutCommonUtil } from '~app/modules/checkout/utils/checkout-common-util';
import * as Sentry from '@sentry/browser';
import { PaymentActionTypes } from '~app/modules/checkout/store/payment';

export function handleError(errorResponse): Observable<ShoppingCartError> {
  const logOrderNumber = CheckoutCommonUtil.getOrderNumberFromLocalForLogging();
  const sessionId = CheckoutCommonUtil.getSessionIdFromSessionStorage();

  Sentry.captureException(errorResponse, {
    tags: {
      action_type: '[app-cart/Cart] cart response',
      flow: 'checkout',
    },
    contexts: {
      checkout: {
        order_number: logOrderNumber,
        session_id: sessionId,
        step: 'cart',
      },
    },
  });

  let message: string;
  let errors: InvalidParams;

  if (errorResponse instanceof GeneralHttpError || errorResponse instanceof BadRequestHttpError) {
    const { title, detail } = errorResponse;
    message = title || detail;
    errors = { common: { reason: message } };

    if (errorResponse instanceof BadRequestHttpError) {
      const { invalidParams } = errorResponse;

      if (!isEmpty(invalidParams)) {
        errors = invalidParams;
      }
    }
  } else {
    message = errorResponse.message ? errorResponse.message : errorResponse.toString();
    errors = { common: { reason: message } };
  }
  return throwError(new ShoppingCartError(message, errors));
}
